import { Link } from "react-router-dom";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { FaHeart } from "react-icons/fa";
import Carousel from "../../components/ui/Carousel";

const round = "rounded-full bg-white text-black opacity-50 hover:opacity-100";

/** Poster strip shared by the bookmarks and purchases tabs. */
const PosterCarousel = ({ items }) => (
  <div className="w-full px-4">
    <div className="mt-[5rem]">
      <Carousel
        arrowClassName="h-full"
        renderNext={() => <MdChevronRight className={round} size={40} />}
        renderPrev={() => <MdChevronLeft className={round} size={40} />}
      >
        {items.map((item) => (
          <Link
            key={`${item.type}-${item.id}`}
            to={
              item.type === "series"
                ? `/series/${item.id}`
                : `/movies/${item.id}`
            }
            className="inline-block align-top"
          >
            <div className="relative h-[220px] w-[140px] cursor-pointer p-2 sm:h-[270px] sm:w-[180px] md:w-[220px] lg:h-[370px] lg:w-[260px]">
              <img
                className="block h-full w-full rounded-xl object-cover"
                src={item.cover}
                alt={item.name ?? item.title}
                loading="lazy"
              />
              <div className="absolute bottom-4 right-4 hidden sm:block">
                {item.like_percent != null && (
                  <p>
                    <FaHeart className="mb-1 ml-1 inline-block text-xl text-gray-300" />
                    {item.like_percent}%
                  </p>
                )}
                {item.director?.[0]?.name && (
                  <p className="text-xs">کارگردان : {item.director[0].name}</p>
                )}
              </div>
            </div>
          </Link>
        ))}
      </Carousel>
    </div>
  </div>
);

export default PosterCarousel;
